import React, { useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import AutocompleteSelect, {
  statusRenderOption,
  statusStartAdornment
} from 'UI/components/molecules/AutocompleteSelect';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { Endpoints } from 'UI/constants/endpoints';
import { UIStatus } from 'UI/constants/status';

import { DetailsSummary } from '../../shared';
import { buildRelatedEntities } from '../../shared/DetailsSummary/DetailsSummary.utils';

import { LoaderContainer, useStyles } from './SendoverDetailsDrawer.styled';
import { SendoverDetailsTabs } from './SendoverDetailsTabs';

const SENDOVER_STATUS_TYPE = 2;

export const SendoverDetailsDrawer = ({ sendoverId, onClose, onConvertToSendout }) => {
  const classes = useStyles();
  const [selectedStatus, setSelectedStatus] = useState(null);

  const { state } = useFetchWithStatusV2({
    endpoint: sendoverId ? `${Endpoints.Sendouts}/${sendoverId}?` : null,
    apiVersion: 1
  });

  const isFetching = state.status === UIStatus.Loading;
  const sendoverStatus = state.results?.status || null;
  const currentStatus = selectedStatus || sendoverStatus;

  const handleStatusChange = (name, value) => {
    setSelectedStatus(value);
    // TODO: Persist the selected sendover status when the update endpoint is defined.
  };

  const buttonDefinitions = [
    {
      props: {
        text: strings.shared.ui.close,
        variant: 'outlined',
        onClick: onClose
      },
      GridItemProps: { md: 3 }
    },
    {
      props: {
        text: 'Convert to Sendout',
        variant: 'contained',
        onClick: onConvertToSendout
      },
      GridItemProps: { md: 9 }
    }
  ];

  const relatedEntities = buildRelatedEntities(state.results);

  return (
    <FPDrawer
      FPDrawerProps={{ open: true, classes: { paper: classes.drawerLarge } }}
      CardHeaderProps={{ title: 'Sendover Details' }}
      onClose={onClose}
      contentContainerClassName={classes.drawerContentContainer}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 1 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <When condition={isFetching}>
        <LoaderContainer>
          <CircularProgress />
        </LoaderContainer>
      </When>
      <When condition={state.status === UIStatus.Success}>
        <div className={classes.drawerSection}>
          <DetailsSummary
            title={state.results?.joborder?.title}
            primaryAction={
              <AutocompleteSelect
                disableClearable
                name="sendoverStatus"
                onSelect={handleStatusChange}
                placeholder="Status"
                selectedValue={currentStatus}
                getOptionSelected={(option, value) => option?.id === value?.id}
                renderOption={statusRenderOption}
                startAdornment={currentStatus?.color && statusStartAdornment(currentStatus.color)}
                url={`${Endpoints.SendoutsStatus}?type=${SENDOVER_STATUS_TYPE}`}
              />
            }
            relatedEntities={relatedEntities}
          />
        </div>
        <SendoverDetailsTabs sendoverId={sendoverId} />
      </When>
    </FPDrawer>
  );
};
